import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TableRow, TableCell, Skeleton } from '@mui/material';
export function TableRowSkelton({ columnCount, rowCount }) {
    return (_jsx(_Fragment, { children: new Array(rowCount).fill('_').map((_, idx) => (_jsx(TableRow, { hover: true, role: "checkbox", tabIndex: -1, sx: { cursor: 'pointer' }, children: new Array(columnCount).fill('_').map((_, indexJ) => {
                return (_jsx(TableCell, { children: _jsx(Skeleton, { variant: "rounded", width: 150 }) }, indexJ));
            }) }, idx))) }));
}
